/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListingState
 */
export interface ListingState {
    /**
     * 
     * @type {string}
     * @memberof ListingState
     */
    metaState: string;
    /**
     * 
     * @type {string}
     * @memberof ListingState
     */
    status: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListingState
     */
    backwardStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListingState
     */
    forwardStatuses?: Array<string>;
}

/**
 * Check if a given object implements the ListingState interface.
 */
export function instanceOfListingState(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "metaState" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function ListingStateFromJSON(json: any): ListingState {
    return ListingStateFromJSONTyped(json, false);
}

export function ListingStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListingState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metaState': json['meta_state'],
        'status': json['status'],
        'backwardStatuses': !exists(json, 'backward_statuses') ? undefined : json['backward_statuses'],
        'forwardStatuses': !exists(json, 'forward_statuses') ? undefined : json['forward_statuses'],
    };
}

export function ListingStateToJSON(value?: ListingState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta_state': value.metaState,
        'status': value.status,
        'backward_statuses': value.backwardStatuses,
        'forward_statuses': value.forwardStatuses,
    };
}

